import { http } from "../../../utils/axios/axios";

export function getTncStatus(agentCode: string) {
  const url = `/agents/tnc-acceptance/${agentCode}`;

  return http.get(url, { headers: { __loading: true } }).then((res) => res.data);
}

export function putTncStatus(agentCode: string) {
  const url = `/agents/tnc-acceptance/${agentCode}`;
  return http.put(url, { headers: { __loading: true } }).then((res) => res.data);
}
